var state = {
    active: false,
    previousPosition: 0,
    currentPosition: 0,
};
var getters = {
    getActive: function (state) {
        return state.active;
    },
    getPosition: function (state) {
        return state.currentPosition;
    },
    getPreviousPosition: function (state) {
        return state.previousPosition;
    },
};
var actions = {
    setPosition: function (_a, position) {
        var commit = _a.commit;
        commit('setPreviousPosition', state.currentPosition);
        commit('setPosition', position);
    },
    setPreviousPosition: function (_a, position) {
        var commit = _a.commit;
        commit('setPreviousPosition', position);
    },
    setActive: function (_a, active) {
        var commit = _a.commit;
        commit('setActive', active);
    },
};
var mutations = {
    setPosition: function (state, position) {
        state.currentPosition = position;
    },
    setPreviousPosition: function (state, previousPosition) {
        state.previousPosition = previousPosition;
    },
    setActive: function (state, active) {
        state.active = active;
    },
};
export default {
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations,
};



//////////////////
// WEBPACK FOOTER
// ./src/stores/modules/tracker.store.ts
// module id = null
// module chunks = 